import React from "react";
import "./LandingPage.css";
import Floaticons from "./Floaticons";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";

function LandingPage() {
  return (
    <>
      <div className="banner-container">
        <img src="images/Banner1.png" alt="banner" className="banner-img" />
      </div>
      <Floaticons />
      <div className="landingPage-main-container">
        {/* Section 1  */}
        <div className="purpose-container">
          <div className="purpose-wrap">
            <div className="purpose-row">
              {/* <div className="purpose-box box1">
                                <img src="images/LandingPage/Description-image.png" alt="description-img" className="purpose-img" />
                            </div> */}
              <div className="purpose-box box2">
                <h2>Purpose</h2>
                <p className="mb1">
                  Our purpose is to serve as true business partner in securing
                  our client's business. We commit to provide multifaceted
                  learning avenues to help build next generation of security
                  leaders.
                </p>
                <Link to="/homeContent">
                  <Button variant="contained" className="explore-button">
                    EXPLORE NOW
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* section 2  */}
        <div className="slf-container">
          <h2>Security Learning Framework</h2>
          <div className="slf-wrap">
            <div className="slf-row">
              <img
                src="images/LandingPage/SecurityLearningFramework-July24.png"
                alt="learn-section"
                className=""
              />
            </div>
          </div>
        </div>

        {/* section 3 */}
        <div className="learn-container">
          <div className="learn-wrap">
            <div className="learn-row">
              <div className="learn-box">
                <img
                  src="images/LandingPage/animation.gif"
                  alt="learn-section"
                  className="learn-img"
                />
              </div>
            </div>
          </div>
        </div>

        {/* section 4  */}
        {/* <div className="statistics-container">
                    <div className="statistics-wrap">
                        <h1>Key Statistics</h1>
                        <div className="statistics-row">
                            <div className="statistics-box">
                                <img src="images/LandingPage/Training-Sessions.png" alt="learn-icon" className="statistics-icon"/>
                                <p className="key-number">10</p>
                                <p className="key-name">Training Sessions</p>
                            </div>
                            <div className="statistics-box">
                                <img src="images/LandingPage/Training-Hours.png" alt="learn-icon" className="statistics-icon"/>
                                <p className="key-number">78</p>
                                <p className="key-name">Training Hours</p>
                            </div>
                            <div className="statistics-box">
                                <img src="images/LandingPage/Certifications.png" alt="learn-icon" className="statistics-icon"/>
                                <p className="key-number">20</p>
                                <p className="key-name">Certifications</p>
                            </div>
                            <div className="statistics-box">
                                <img src="images/LandingPage/Women-employees-trained.png" alt="learn-icon" className="statistics-icon"/>
                                <p className="key-number">58</p>
                                <p className="key-name">Women <br/>employees trained</p>
                            </div>
                            <div className="statistics-box">
                                <img src="images/LandingPage/Cyberbit-trained.png" alt="learn-icon" className="statistics-icon"/>
                                <p className="key-number">59</p>
                                <p className="key-name">Cyberbit trained</p>
                            </div>
                            <div className="statistics-box">
                                <img src="images/LandingPage/CyberHER-trained.png" alt="learn-icon" className="statistics-icon"/>
                                <p className="key-number">80</p>
                                <p className="key-name">CyberHER trained</p>
                            </div>
                        </div>
                    </div>
                </div> */}
      </div>
    </>
  );
}

export default LandingPage;
